import { render, staticRenderFns } from "./RestBridgeDialog.vue?vue&type=template&id=4d243852&"
import script from "./RestBridgeDialog.vue?vue&type=script&lang=js&"
export * from "./RestBridgeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports